import { useFormik } from 'formik';
import { PasswordScreenProps } from '@packages/shared/core/quiz/entities';
import { DataTestId } from '@packages/shared/core/common/constants/dataTestId';
import Header from '@packages/shared/core/common/components/layout/Header';
import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import TextField from '@packages/shared/core/common/components/common/TextField';
import Button from '@packages/shared/core/common/components/common/Button';
import styles from './PasswordScreen.module.scss';

const minPasswordLength = 6;

const PasswordScreen = ({ onBack, content, signUp }: PasswordScreenProps) => {
  const { getFieldProps, handleSubmit, errors, touched, isSubmitting } = useFormik({
    initialValues: {
      password: '',
    },
    onSubmit: async ({ password }, formikHelpers) => {
      await signUp(password, formikHelpers);
    },
    validate: async ({ password }) => {
      const err = {};
      if (password.length < minPasswordLength) {
        Object.assign(err, {
          password: 'Password must be at least 6 characters long',
        });
      }

      if (!password) {
        Object.assign(err, { password: 'Password is required' });
      }

      return err;
    },
  });

  const passwordError = touched.password && !!errors.password ? errors.password : '';

  return (
    <>
      <Header className={styles.header} menuClassName={styles.menu}>
        <ButtonBack className={styles.buttonBack} secondary onClick={onBack} />
      </Header>

      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <h2 className={styles.title}>{content.title}</h2>

          <h3 className={styles.subtitle}>{content.subtitle}</h3>

          <form onSubmit={handleSubmit} className={styles.container}>
            <TextField
              label="Enter your password"
              id="password"
              {...getFieldProps('password')}
              error={passwordError}
              placeholder="Enter your password"
              type="password"
              wrapperClass={styles.inputWrapper}
              labelProps={{
                className: styles.label,
              }}
              data-testid={DataTestId.PASSWORD_FIELD}
            />

            <Button
              wrapperClassName={styles.buttonWrapper}
              type="submit"
              disabled={isSubmitting}
              className={styles.button}
              loading={isSubmitting}
              data-testid={DataTestId.SUBMIT_BUTTON}
            >
              Continue
            </Button>
          </form>
        </div>
      </div>
    </>
  );
};

export default PasswordScreen;
